'use strict';

// onPageLoad — replacement for `DOMContentLoaded` init under Turbo Drive (F-15).
//
// Turbo Drive swaps the <body> on each visit without firing DOMContentLoaded, so
// per-view init that listened for it silently stopped running after the first
// full load. `turbo:load` fires on the initial load AND after every Turbo visit,
// so we key off that instead.
//
// Two problems this guards against:
//  1. Cross-page firing. Per-view bundles are ES modules (execute once per URL),
//     but the turbo:load listener they register persists and fires on every
//     later visit — including unrelated pages, where the view's DOM is absent
//     and its init would throw. Pass `view` (matching <body data-view>) to gate.
//  2. Double / missed init from a race. Whether turbo:load fires before or after
//     a freshly-appended view module executes, we must run exactly once. Turbo
//     replaces the <body> element per visit, so a flag stored on body.dataset is
//     fresh each visit: first caller (event or immediate) runs and sets it, the
//     other sees it and skips.
//
// base-level callers omit `view` to run on every page.
export function onPageLoad(view, fn) {
  if (typeof view === "function") { fn = view; view = null; }
  const flag = "pl_" + (view || "base");

  const run = () => {
    if (view && document.body.dataset.view !== view) return;
    if (document.body.dataset[flag]) return;
    document.body.dataset[flag] = "1";
    fn();
  };

  document.addEventListener("turbo:load", run);
  // If this module executed after turbo:load already fired for the current
  // visit, the event listener above missed it — run now (the flag dedupes).
  if (document.readyState !== "loading") run();
}
